export class ChaseOrderInvoiceProcessOutput {
    transactionId: string;
    orderIds: string;
    invoiceIds: string;
    amountPaid: string;
    transactionStatus: string;
    paymentMode: string;
}
